import React, { useCallback, useRef, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Divider, Stack, Box, Typography as Muitypo, Card, Grid } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { Icon } from '@iconify/react';
import Page from '../components/Page/Page';
import Breadcrumbs from '../components/BreadCrumbs/BreadCrumbs';
import { PATHS } from '../utils/constants';
import { Button, Label, Link, Tabs, TextField, Typography, Chip } from '../components';
import Loader from '../modules/CarList/Loader';

import PendingAssignments from '../modules/Assignments/PendingAssignments';
import ApprovedAssignmentsGrid from '../modules/Assignments/ApprovedAssignmentsGrid';
import RejectedAssignmentGrid from '../modules/Assignments/RejectedAssignmentGrid';
import OnHoldAssignmentGrid from '../modules/Assignments/OnHoldAssignmentGrid';
import ApprovedAssignmentsGridNew from '../modules/Assignments/ApprovedAssignmentsGridNew';
import RejectedAssignmentsGridNew from '../modules/Assignments/RejectedAssignmentsGridNew';

const Assignment = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [active, setActive] = useState(0);
  useEffect(() => {
    const path = pathname.split('/v360-app/');
    if (pathname.includes('approved')) {
      setActive(1);
    }
    if (pathname.includes('rejected')) {
      setActive(2);
    }
    if (pathname.includes('on-hold')) {
      setActive(3);
    }
  }, [pathname]);

  // constants
  const links = [
    {
      label: 'Dashboard',
      link: PATHS.dashboard,
    },
    {
      label: 'Assignment',
      link: PATHS.vehicles,
    },
  ];
  const navData = [
    {
      label: 'Pending Requests',
      onClick() {
        navigate('/v360-app/assignment');
        setActive(0);
      },
      content: <PendingAssignments />,
    },
    {
      label: 'Approved',
      onClick() {
        navigate('/v360-app/assignment/approved');
        setActive(1);
      },
      content: <ApprovedAssignmentsGridNew />,
      // content: <ApprovedAssignmentsGrid />,
    },
    {
      label: 'Rejected',
      onClick() {
        navigate('/v360-app/assignment/rejected');
        setActive(2);
      },
      content: <RejectedAssignmentsGridNew />,
      // content: <RejectedAssignmentGrid />,
    },
    {
      label: 'On Hold',
      onClick() {
        navigate('/v360-app/assignment/on-hold');
        setActive(3);
      },
      content: <OnHoldAssignmentGrid />,
    },
  ];

  return (
    <Page sx={{ p: 0.5 }}>
      <Breadcrumbs links={links} />
      <Divider sx={{ mt: 1, opacity: 0.7 }} />
      <Stack direction="row" p={1} alignItems="center" gap={1}>
        <Muitypo variant="h6" component="h2" flexGrow={1}>
          Assignment
        </Muitypo>
      </Stack>

      <Tabs active={active} tabItems={navData} />
    </Page>
  );
};
export default Assignment;
